// モーダルウインドウ用スクリプト
const modalTriggers = document.querySelectorAll('.modal-trigger');
const closeButtons = document.querySelectorAll('.close-button');
const overlays = document.querySelectorAll('.modal-overlay');

// 開く処理
modalTriggers.forEach(trigger => {
    trigger.addEventListener('click', () => {
        const targetId = trigger.getAttribute('data-target');
        const targetModal = document.getElementById(targetId);
        if (targetModal) {
            targetModal.style.display = 'flex';
            document.body.classList.add('no-scroll');
        }
    });
});

// 既存の取得コードに以下を追加
const footerCloseBtns = document.querySelectorAll('.footer-close-btn');

// 閉じるときの共通処理（既存のものがあればそれを使います）
const closeModal = (modal) => {
    modal.style.display = 'none';
    document.body.classList.remove('no-scroll');
};

// 右上のボタン用
closeButtons.forEach(button => {
    button.addEventListener('click', () => closeModal(button.closest('.modal-overlay')));
});

// 追加：下部のボタン用
footerCloseBtns.forEach(button => {
    button.addEventListener('click', () => closeModal(button.closest('.modal-overlay')));
});

// 背景クリック用
overlays.forEach(overlay => {
    overlay.addEventListener('click', (e) => {
        if (e.target === overlay) closeModal(overlay);
    });
});

// 対象のモーダル要素を取得
const modal = document.getElementById('modal_extension');

if (modal) {
  // bodyタグの最後（直下）に移動させる
  document.body.appendChild(modal);
  
  // 移動後に表示状態を確認・制御する場合
//  modal.style.display = 'flex';
//  modal.style.zIndex = '9999';
}



// 【BON】スマホの検索窓（2026-10-28）
// ・🔍をタップ → 検索窓を全画面で開いてキーボードを出す。開いている間はヘッダーの🔍を隠す
// ・検索窓の右のボタンは「閉じる」の文字をやめて【×】にし、押すと検索窓を閉じて🔍を戻す
// ・入力途中のキーワードは閉じても残す（押し間違えたときに打ち直さずに済むように）。消すときは入力欄の中の×
// 旧：🔍→検索窓が出るだけ→窓をタップで全画面、「閉じる」でも窓が残り🔍をもう一度押す必要があった
// ※以前ここにあった「スクロールで検索窓を隠す」処理は、隠すCSSが無く効いておらず、毎スクロールでエラーになっていたため削除
(() => {
  const isPhone = () => window.matchMedia('screen and (max-width: 640px)').matches;
  const wrapper = document.querySelector('.header__search-bar-wrapper');
  const toggle = document.querySelector('[data-action="toggle-search"]');
  if (!wrapper || !toggle) return;
  const input = wrapper.querySelector('[name="q"]');
  const closeButton = wrapper.querySelector('[data-action="unfix-search"]');
  if (!input || !closeButton) return;

  const style = document.createElement('style');
  style.textContent = `
    @media screen and (max-width: 640px) {
      .header--search-expanded [data-action="toggle-search"] { visibility: hidden; }
      /* 開くときは即表示にする（テーマの0.25秒かけて表示だと、🔍直後は非表示扱いで入力欄にフォーカスできない） */
      .header__search-bar-wrapper.is-visible { transition: margin-bottom 0.25s ease-in-out; }
      /* 【×】は全画面になる前から出す（キーボードが出なかった場合も閉じられるように） */
      .header__search-bar-wrapper.is-visible .search-bar__close-button { width: auto !important; height: auto; opacity: 1; white-space: nowrap; }
      .search-bar__close-button .bon-close-x { display: flex; align-items: center; padding-left: 16px; }
    }`;
  document.head.appendChild(style);

  closeButton.setAttribute('aria-label', '閉じる');
  closeButton.innerHTML =
    '<span class="bon-close-x"><svg width="22" height="22" viewBox="0 0 22 22" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 3l16 16M19 3L3 19"/></svg></span>';

  document.addEventListener('click', (e) => {
    if (!isPhone()) return;

    // 🔍：テーマが検索窓を開いた直後に入力欄へフォーカスして、全画面＋キーボードにする
    if (e.target.closest('[data-action="toggle-search"]')) {
      if (wrapper.classList.contains('is-visible')) input.focus();
      return;
    }

    // 【×】：テーマの全画面解除のあと、検索窓もたたむ（テーマの🔍の処理を通して開閉状態をそろえる）
    if (e.target.closest('[data-action="unfix-search"]')) {
      input.blur();
      if (wrapper.classList.contains('is-visible')) toggle.click();
    }
  });
})();